import { paraCampoDataHora } from '@/lib/formato';

import { CAMPOS_DO_CADASTRO, valoresDe, type Referencia } from './campos';
import type { LinhaDeCadastro, TipoDeCadastro } from './tipos';

/**
 * O QUE O CADASTRO JÁ VEM SABENDO (pente fino de 31/10/2026: "facilitar e
 * agilizar ao máximo a vida de quem vai usar o sistema").
 *
 * Duas respostas que o sistema dá antes de a pessoa perguntar, e as duas com
 * a marca de pré-preenchido, que some quando ela mexe no campo:
 *
 *  - o INÍCIO DA VIGÊNCIA do contrato novo é hoje — é o caso de quem cadastra
 *    o contrato que acabou de assinar; o retroativo troca a data;
 *  - a FILIAL, quando a empresa tem UMA SÓ, já vem escolhida no cadastro novo.
 *    O campo continua opcional e continua lista: "Sem filial" segue sendo uma
 *    resposta, a um clique. (A regra da opção única, `lib/escolha-unica.ts`,
 *    trava só o campo obrigatório; aqui é sugestão, não trava.)
 *
 * Na EDIÇÃO nada disso acontece: o que está gravado é a resposta.
 *
 * Puro, para o teste provar as duas regras sem desenhar a tela.
 */

export interface ValoresIniciais {
  readonly valores: Record<string, string>;
  /** Os campos que o SISTEMA escreveu, e que a tela marca. */
  readonly preenchidos: ReadonlySet<string>;
}

export function valoresIniciais(tipo: TipoDeCadastro, linha: LinhaDeCadastro | null, hoje: Date): ValoresIniciais {
  const valores = valoresDe(tipo, linha);
  if (linha !== null) return { valores, preenchidos: new Set() };
  const preenchidos = new Set<string>();
  if (CAMPOS_DO_CADASTRO[tipo].some((c) => c.nome === 'inicio' && c.especie === 'data') && (valores['inicio'] ?? '') === '') {
    valores['inicio'] = paraCampoDataHora(hoje).slice(0, 10);
    preenchidos.add('inicio');
  }
  return { valores, preenchidos };
}

/**
 * A referência que o cadastro novo já pode trazer escolhida: a da lista com UM
 * item só, quando o campo ainda está vazio e é de uma referência que se sugere
 * (hoje, só a filial). `null` quando não há o que sugerir.
 */
export function sugestaoDaReferencia(entrada: {
  readonly referencia: Referencia | undefined;
  readonly cadastrando: boolean;
  readonly valor: string;
  /** Os `id` da lista, já sem os arquivados. `undefined` enquanto ela não chegou. */
  readonly opcoes: readonly string[] | undefined;
}): string | null {
  if (!entrada.cadastrando || entrada.valor !== '' || entrada.referencia !== 'filiais') return null;
  if (entrada.opcoes === undefined || entrada.opcoes.length !== 1) return null;
  return entrada.opcoes[0] ?? null;
}
